<!--
Use ngx-loading-bar/http-client when load this page.
-->
<ngx-loading-bar [color]="'white'"></ngx-loading-bar>
<!-- / -->
<p-toast position="center"></p-toast>

<main class="w-full px-4">
  <div class="mx-auto max-w-7xl">
    <!-- Breadcrumbs -->
    <nav class="flex mt-12" aria-label="Breadcrumb">
      <ol role="list" class="flex items-center space-x-4">
        <li>
          <div>
            <a [routerLink]="['/']" class="text-gray-400 hover:text-pink-800">
              <svg class="h-5 w-5 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M9.293 2.293a1 1 0 011.414 0l7 7A1 1 0 0117 11h-1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-6H3a1 1 0 01-.707-1.707l7-7z" clip-rule="evenodd" />
              </svg>
              <span class="sr-only">Início</span>
            </a>
          </div>
        </li>

        <li>
          <div class="flex items-center">
            <svg class="h-5 w-5 flex-shrink-0 text-pink-800" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
              <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
            </svg>
            <a class="ml-4 text-sm font-medium text-gray-500 hover:text-pink-800" aria-current="page">Sobre Nós</a>
          </div>
        </li>
      </ol>
    </nav>

    <div class="relative isolate overflow-hidden bg-white py-20">
      <div>
        <div>
          <p class="text-lg font-medium leading-8 tracking-tight text-gray-900">A gente quer te convidar para conhecer a família</p>
          <h1 class="mt-1 text-3xl font-bold tracking-tight text-pink-900 sm:text-4xl">#EuSouGe!</h1>
          <p class="mt-6 text-lg leading-8 text-gray-700">Ser Gê é estar antenado com as principais evoluções, seja no cuidado com a casa, roupas, na moda, internet e a mudança constante de como as pessoas consomem informações e produtos. Ser Gê é saber o valor do tempo!</p>
        </div>
        <div class="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-10 gap-y-16 lg:mx-0 lg:mt-10 lg:max-w-none lg:grid-cols-12">
          <div class="relative lg:order-last lg:col-span-6">
            <figure class="border-l border-amber-500 pl-8">
              <blockquote class="text-3xl leading-8 tracking-tight text-gray-900">
                <p><span class="font-extrabold">“A Casa de Gê é muito mais</span> que uma plataforma digital de vendas online.”</p>
              </blockquote>
            </figure>
            <div class="mt-10"><img src="/assets/images/devices.png" alt="Dispositivos Eletrônicos" /></div>
          </div>
          <div class="max-w-xl text-base leading-7 text-gray-700 lg:col-span-6">
            <p>
              A gente sabe que a vida é uma correria! Não é fácil, mas é exatamente pra te ajudar na missão: <b><i>“dar conta de tudo”</i></b
              >, <b>que existe a Casa de Gê!</b><br /><br />
              É o lugar perfeito para você encontrar as melhores soluções em limpeza e ser cada vez mais prática, inovadora, moderna e dinâmica. <br /><br />Aqui na Casa de Gê, você tem à disposição as principais soluções na hora de limpar sua casa, escritório ou roupas, com preços e vantagens exclusivas, além de diversos conteúdos, com sugestões e dicas
              para tornar sua vida mais prática, otimizada e com mais tempo para fazer as coisas que você <b>mais ama.</b><br /><br /><b>Casa de Gê</b> faz parte da <b>GTEX</b> que é uma empresa especializada em trazer praticidade e qualidade de vida para a família brasileira, oferecendo ampla gama de produtos de limpeza para a sua casa.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
